export default __webpack_public_path__ + "static/media/analyticAccountIcon.2a7727e8.svg";